import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import {
	UserOnlineStatusArgument,
	UserOnlineStatusModel,
} from './realtime.model';

@Injectable({
	providedIn: 'root',
})
export class RealtimeService {
	constructor(private httpClient: HttpClient) {}

	public sendUserTypingNotification = (
		targetUids: number[],
		channelId: number,
		typingUserLinkId: number,
		active: boolean,
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(`/api/v1/realtime/typing-status`, {
				uids: targetUids,
				message: [channelId, typingUserLinkId, active],
			})
			.pipe(
				mapResponse((r) => r, {
					errorCode: '258B21D5',
				}),
			);
	};

	public getUserOnlineStatus = (
		args: UserOnlineStatusArgument,
	): Observable<UserOnlineStatusModel> => {
		return this.httpClient
			.post<UserOnlineStatusModel>(`api/v1/realtime/users/online-status`, args)
			.pipe(
				mapResponse((r) => plainToInstance(UserOnlineStatusModel, r), {
					errorCode: '5932B0AB',
				}),
			);
	};
}
